import React from "react";
import Sidebar from "../Components/common/Sidebar";
import Topbar from "../Components/common/Topbar";

export default function AdminShell({ children }) {
  return (
    <div className="min-h-screen w-full bg-[#dfedff36] text-gray-900">
      <div className="flex">
        {/* fixed-width sidebar */}
        <div className="shrink-0">
          <Sidebar />
        </div>

        {/* main area */}
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="sticky top-0 z-20">
            <Topbar />
          </div>
          <main className="p-1 lg:p-4">{children}</main>
        </div>
      </div>
    </div>
  );
}
